export const API_ERRORS = {
  NETWORK: {
    code: 'API_NETWORK_ERROR',
    message: 'Network error. Please try again.',
  },
  UNAUTHORIZED: {
    code: 'API_UNAUTHORIZED',
    message: 'Please log in to continue.',
  },
  UNKNOWN: {
    code: 'API_UNKNOWN_ERROR',
    message: 'Something went wrong.',
  },
};

export function resolveApiErrorMessage(status) {
  if (status === 401 || status === 403) return API_ERRORS.UNAUTHORIZED.message;
  return API_ERRORS.UNKNOWN.message;
}
